export const MAJOR_INDIAN_CITIES = [
  'Mumbai',
  'Goa'
];
